let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bnQBE")).then(() => parcelRequire('h1w7n'));